// 跟ua相关的方法

/**
 * 判断是否在微信环境
 */
export function isInWeixin(): boolean {
  const ua = navigator.userAgent.toLowerCase();
  const result = ua.match(/MicroMessenger/i) || [];
  return result[0] === 'micromessenger';
}
